export default __webpack_public_path__ + "static/media/les_andelys07.b0cbf27f.jpg";